import { create } from "zustand";
const useinvoiceStore = create<InvoiceStore>((set, get) => ({
  jobInfo: {
    Discount: 0,
    OutstandingDues: 0,
    VATAmount: 0,
    CustomerName: "",
    CustomerAddress: "",
    SalesPerson: "",
    PortOfOrigin: "",
    PortOfDestination: "",
    Weight: "",
    Dimensions: "",
    TransitTime: "",
    ShipmentTerms: "",
    CarrierName: "",
    ContainerType: "",
    CustomContainerType: "",
    AirportOfDestination: "",
    AirportOfOrigin: "",
    TypeOfCargo: "",
    isAirinquiry: false,
    CustomerTRN: "",
    Departure: "",
    EstimatedArrival: "",
    CustomerEmail: "",
    CustomerPhoneNo: "",
    FlightInformation: "",
    type: "",
    DriverDetails: "",
    PlaceOfDestination: "",
    PlaceOfOrigin: "",
    RouteDetails: "",
    VehicleDetails: "",
    ShippingLaneDetails: "",
    VesselDetails: "",
    VesselName: "",
    Jobid: "",
    jobInitials: "",
    method: "",
    othershippingDetails: "",
    quotationId: "",
    address: "",
  },
  ladleInfo: {
    ConsigneeReference: "",
    CustomerName: "",
    CustomerAddress: "",
    SalesPerson: "",
    PlaceOfOrigin: "",
    PlaceOfDestination: "",
    VesselName: "",
    RouteDetails: "",
    TypeOfCargo: "",
    Weight: "",
    TransitTime: "",
    ShipmentTerms: "",
    CarrierName: "",
    TotalContainers: 0,
    CustomerTRN: "",
    CustomerEmail: "",
    CustomerPhoneNo: "",
    VesselDetails: "",
    othershippingDetails: "",
    ExportReference: "",
    ForwardingAgent: "",
    PortOfDischarge: "",
    PortOfLoading: "",
    jobInitials: "",
    method: "",
    PlaceOfIssue: "",
    PlaceOfReceipt: "",
    PayableAt: "",
    PlaceOfDelivery: "",
    Movement: "",
    NotifyAddress: "",
    Currency: "",
    address: "",
    Discount: 0,
    Jobid: "",
    OutstandingDues: 0,
    VATAmount: 0,
    specialInstructions: "",
    termsAndConditions: "",
  },
  AirwayInfo: {
    CustomerName: "",
    CustomerAddress: "",
    SalesPerson: "",
    AirportOfOrigin: "",
    AirportOfDestination: "",
    RouteDetails: "",
    TransitTime: "",
    FlightDetails: "",
    ShipmentTerms: "",
    CarrierName: "",
    CustomerTRN: "",
    CustomerAccount: "",
    CustomerEmail: "",
    CustomerPhoneNo: "",
    othershippingDetails: "",
    jobInitials: "",
    method: "",
    Currency: "",
    Flight: "",
    ReferenceNumber: "",
    HandlingInformation: "",
    address: "",
    Discount: 0,
    AccountingInformation: "",
    PaymentMethod: "",
    RequestedFlight: "",
    Jobid: "",
    OutstandingDues: 0,
    VATAmount: 0,
    specialInstructions: "",
    termsAndConditions: "",
  },
  setAirwayBillItems(j) {
    set((state) => {
      return { ...state, AirwayItems: j };
    });
  },
  setAirwayInfo(j) {
    set((state) => ({ ...state, AirwayInfo: j }));
  },
  Items: [],
  AirwayItems: [],
  setInfo(j) {
    set((state) => ({ ...state, jobInfo: j }));
  },
  setItems(j) {
    set((state) => {
      return { ...state, Items: j };
    });
  },
  ladingItems: [],
  setladingItems(j) {
    set((state) => {
      return { ...state, ladingItems: j };
    });
  },
  setladleInfo(j) {
    set((state) => ({ ...state, ladleInfo: j }));
  },
}));

export default useinvoiceStore;
